<tm-menubar-button [active$]="visible$"
                   (buttonClicked)="toggleAttributeList()"
                   [tooltip]="title$ | async"
                   icon="components_attribute_list"></tm-menubar-button>
